import { CropSquare } from "@mui/icons-material";
import { Box, Grid2, IconButton, SvgIcon, Tooltip, Typography, useTheme } from "@mui/material";
import { useTranslation } from "react-i18next";
import { conferenceIcon } from "./ZoneSideToolbar.partial";
import { IZone, IZoneType } from "../../../Domain/Types/FloorPlan/Zone.type";
import { adjustZoneType } from "../../Views/CreateFloorPlanView/Tools/useFloorplan/useFloorplan";

interface Props {
  typeOfZone: number;
  setTypeOfZone: (t: number) => void;
  availableTypes: IZone[];
}

export function ZoneSideToolbar({ typeOfZone, setTypeOfZone, availableTypes }: Readonly<Props>) {
  const { t } = useTranslation();
  const theme = useTheme();

  /**
   * conference zone is able to draw regardless of booking availability
   * @see FE issue #1376
   */
  const avaialbleTypeNames = adjustZoneType(availableTypes).map(t => t.name);

  return (
    <>
      {/* select zone type */}
      <Box
        sx={theme => ({
          border: "1px solid #00000088",
          backgroundColor: "#ffffff",
          opacity: 0.95,
          position: "absolute",
          top: 168,
          m: 1,
          borderRadius: 2,
          ...theme.applyStyles("dark", {
            backgroundColor: "#000000"
          })
        })}
      >
        <Grid2 container sx={{ width: 100 }}>
          {/** create zone type 1 standard */}
          {avaialbleTypeNames.includes(IZoneType.PLACEZONE) && (
            <Grid2
              size={{ xs: 6 }}
              sx={[
                { borderRadius: 2 },
                typeOfZone === 1 ? { backgroundColor: "blue" } : { backgroundColor: null }
              ]}
            >
              <Tooltip title={<Typography>{t("Standard")}</Typography>} aria-label={"Standard"}>
                <IconButton
                  data-testid="btn-select-znType-1"
                  onClick={() => {
                    setTypeOfZone(1);
                  }}
                  size={"large"}
                >
                  <CropSquare sx={[typeOfZone === 1 ? { color: "white" } : { color: null }]} />
                </IconButton>
              </Tooltip>
            </Grid2>
          )}
          {/** create zone type 3 conference */}
          <Grid2
            size={{ xs: 6 }}
            sx={[
              { borderRadius: 2 },
              typeOfZone === 3 ? { backgroundColor: "blue" } : { backgroundColor: null }
            ]}
          >
            <Tooltip
              title={<Typography>{t("_zonetypeMeetingRoom")}</Typography>}
              aria-label={"Conference"}
            >
              <IconButton
                data-testid="btn-select-znType-3"
                onClick={() => {
                  setTypeOfZone(3);
                }}
                size={"large"}
                sx={{ padding: "13px 7px 7px 12px" }}
              >
                <SvgIcon
                  data-testid={"conference-icon"}
                  sx={{ width: 30, height: 30 }}
                  // viewBox="0 0 30 30"
                >
                  {conferenceIcon({
                    themeMode: theme.palette.mode,
                    zoneType: typeOfZone,
                    iconSize: 20
                  })}
                </SvgIcon>
              </IconButton>
            </Tooltip>
          </Grid2>
        </Grid2>
      </Box>
    </>
  );
}
